$(document).ready(function(){
    getMarkets();
});
function getMarkets(){
    PostMethodFunction('/WebPage/Market/Get', {}, null, showMarkets, null);
}
function showMarkets(response){
    let markets = response.data;
    let appendContent = '';
    $.each(markets, function(index, market){
        appendContent += '<li class="market-item update-market-item" market-id="'+market.id+'">';
            appendContent += '<div class="market-image" style="background-image: url('+market.image_path+')"></div>';
            appendContent += '<h1 class="title-input">'+market.title+'</h1>';
            appendContent += '<p class="header-input">'+market.header.replaceAll('\n', '<br>')+'</p>';
            // appendContent += '<ul class="icons-list">';
            // $.each(market.icons, function(i, icon){
            //     appendContent += '<li class="icon-item">';
            //         appendContent += '<img class="image-icon" src="'+(market.icons[i].icon_path)+'" style="display: block;">';
            //     appendContent += '</li>';
            // });
            // appendContent += '</ul>';
            appendContent += '<p class="footer-input">'+market.footer.replaceAll('\n', '<br>')+'</p>';
            appendContent += '<button class="button-input"><a href="'+market.button_link+'">'+market.button_text+'</a></button>';
        appendContent += '</li>';
    });
    $('#market-list').html(appendContent);
}
